import { camelCaseToReadableFormat, cn } from 'lib/helpers/utility';

import Button from 'components/shared/Button/Button';
import Icon from 'components/shared/Icon/Icon';
import Switch from 'components/shared/Switch/Switch';
import Typography from 'components/shared/Typography/Typography';

const ColumnDragLabel = ({ col, disabled }) => (
  <div className="flex gap-1">
    <Icon icon="drag-drop-linear" />
    <Typography
      variant="label"
      size="medium"
      color="neutral-800"
      className={cn('cursor-grab', disabled && 'cursor-not-allowed')}>
      {col.headerName || camelCaseToReadableFormat(col.field)}
    </Typography>
  </div>
);

/**
 * @type {import('./lib/types').RenderColumnItemProps}
 */

export const RenderColumnItem = ({
  col,
  index,
  onChange,
  onPinChange,
  pin,
  disabled,
  disabledActions = []
}) => {
  const disableLeftPin = disabledActions.includes('left') && disabled;
  const disableRightPin = disabledActions.includes('right') && disabled;

  return (
    <>
      <ColumnDragLabel col={col} disabled={disabled} />
      <div className="flex items-center gap-2">
        <Switch
          checked={!col.hide}
          disabled={disabled}
          onChange={() =>
            onChange((prev) =>
              prev.map((item, i) => (i === index ? { ...item, hide: !item.hide } : item))
            )
          }
        />
        {pin && (
          <div className="flex items-center gap-1">
            <Button.Group variant="tertiary" size="xs" iconSize={16} color="neutral" shade={700}>
              <Button
                icon="chevron-left-linear"
                onClick={() => onPinChange('left', index)}
                isDisabled={disableLeftPin}
                className={cn(
                  '-mr-1 p-1',
                  (col.pinned === true || col.pinned === 'left') && 'bg-neutral-100',
                  disableLeftPin && 'opacity-50'
                )}
              />
              <Button
                icon="chevron-right-linear"
                onClick={() => onPinChange('right', index)}
                isDisabled={disableRightPin}
                className={cn(
                  'p-1',
                  col.pinned === 'right' && 'bg-neutral-100',
                  disableRightPin && 'opacity-50'
                )}
              />
            </Button.Group>
          </div>
        )}
      </div>
    </>
  );
};
